module.exports = __webpack_public_path__ + "img/fisdaf-logo-no-bg.fa4ecf08.png";